import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-[999] grid h-screen w-screen place-items-center" }
const _hoisted_2 = { class: "bg-mono-ns-100 rounded-3xl w-[295px] flex flex-col p-6 xl:p-10 font-sans" }
const _hoisted_3 = { class: "btn-wrapper flex flex-col items-center mb-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "w-4 h-4 checked",
  xmlns: "http://www.w3.org/2000/svg"
}

import {computed, ref} from "vue"
import {useContentStore} from "../store/content";
import {useStore} from "../store";

export type ActionButton = {
    label: string, // display text
    action: string, // action to perform
    selected: boolean, // display style
    onclick: () => void | boolean, // callback
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const store = useStore()
const contentItem = useContentStore()
const selectedLang = ref(contentItem.itemId)

const buttons = computed((): ActionButton[] => {
    let buttons: ActionButton[] = []
    for (const language of contentItem.languages){
        buttons.push({
            label: language.name,
            selected: language.id === selectedLang.value,
            action: `${language.id}-${language.id === selectedLang.value}`,
            onclick: () => {
                selectedLang.value = language.id
            }
        } as ActionButton)
    }
    return buttons
})

function handleSubmit(e: MouseEvent){
    e.preventDefault()
    emit('toggle')
    if (selectedLang.value !== store.itemId)
        store.switchItem(selectedLang.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col gap-4 xl:gap-6 mb-6 xl:mb-10 items-center xl:items-start" }, [
        _createElementVNode("div", { class: "flex flex-col gap-6" }, [
          _createElementVNode("h1", { class: "text-h3m xl:text-tf3 font-bold text-mono-white text-center xl:text-left" }, "Language")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (button) => {
          return (_openBlock(), _createElementBlock("button", {
            type: "button",
            key: button.action,
            class: _normalizeClass(["flex items-center gap-2 p-4 cursor-pointer font-bold text-center text-mono-white w-full hover:bg-mono-ns-200", {'bg-mono-ns-200': button.selected}]),
            onClick: button.onclick
          }, [
            (button.selected)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[0] || (_cache[0] = [
                  _createElementVNode("use", { href: "#icon-check" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(button.label), 1)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "p-2.5 self-end font-bold text-mono-white mb-4 xl:mb-0",
        onClick: handleSubmit
      }, " OK ")
    ])
  ]))
}
}

})